import _ = require("underscore");
import $ = require("jquery");
import Mn = require("backbone.marionette");
import Mediator = require("../mediator");
import MapController = require("../controls/map");
import AppView = require("../views/AppLayoutView");

import Portal = require("portal-gis");
import Utils = require("../utils");
import Api = require("../app");
import Controller = require("../controls/controller"); // for typesafety only
import Templates = require("../models/defaults");
const log = Utils.log;

/**
this is the rhythm gis application which contains a map; the AppView is the 'mediator'
TODO: can this derive from controls/controller instead?  How is this distinct from app?
*/
class RhythmGIS extends Mn.Application {

    static about = `
A Marionette Application utilizing _mediator_ to manage a map.
The _mediator_ facilitates messaging, data sharing and safe(1)
access to views (they initialize asynchronously).

The controller logic is confusing because it creates the application
view and stores it with the mediator *after* it starts watching
the mediator for this same view and trigger the creation of a map view.

| Mediator Properties | Description |
|:------------------- |:----------- |
|view|the view to render into the _region_ identified via configuration|


    `;

    static options = {
        "css": {
            "about": "css file to load",
        },
        "css-name": {
            "about": "The class name to assign to the view",
            "default": "applet._id_",
        },
        "region": {
            "about": "region to use for this view",
            "default": "applet-region",
        },
        "template": {
            "about": "",
            "default": "app/templates/rhythm-gis-template-_applet.id_",
        },
    }

    private _config: Rhythm.GIS.Dictionary<string>;

    get config() {
        return this._config = this._config || Utils.asDictionary(this.applet.Options.Values);
    }

    constructor(private api: Api, private applet: Portal.MapApplicationElement) {
        super();

        let mediator = this.mediator;

        let options = _.defaults(this.config, {
            "region": RhythmGIS.options.region.default,
            "css-name": this.applet.id,
            template: `app/templates/rhythm-gis-template-${this.applet.id}`
        });

        // load app-level styling
        options["css"] && Utils.withCss(options["css"]);

        // render the view into the target region (if available)
        {
            log("registering mediator command: 'view'");
            mediator.on("view", args => {
                let control = args.out.control;

                let options = _.defaults(args.out.controller.options, {
                    region: control.id
                });

                let regionName = options["region"];

                log(`init controller view ${control.id} into region ${regionName}`);

                mediator.appView(appView => {

                    var region = appView.getRegion(regionName);
                    if (!region) {
                        log("failed to find region:", regionName);
                        return;
                    }
                    if (!region) {
                        console.warn("creating region:", regionName);
                        // TODO: remove #
                        ["#", "."].some(selector => {
                            var regionNode = $(selector + regionName, appView.$el);
                            if (regionNode[0]) {
                                region = appView.addRegion(regionName, selector + regionName);
                                regionNode.show();
                                return true;
                            }
                        });
                        if (!region) {
                            console.warn("failed to create region:", regionName);
                            let controller = args.out.controller;
                            if (!controller) {
                                console.warn("failed to find controller");
                                return;
                            }
                            controller = mediator.extend(controller.configuration).controller;
                            if (!controller || !controller.configuration || !controller.show) {
                                console.warn("failed to find containing controller");
                                return;
                            }
                            console.warn("containing controller found, attempting to show view with that controller: ", controller.configuration.id);
                            controller.show(args.out);
                            return;
                        }
                    }
                    if (region.hasView()) {
                        console.warn("region already has view: ", region.el.id);
                    }

                    log(`showing controller view ${control.id} in region ${regionName}`);
                    region.show(args.out.view);
                });
            });
        }

        // callback template is null if not found
        Utils.withTemplate(options["template"], template => {

            // create this apps only view
            let rootView = new AppView(<any>this, {
                className: `maplet-region ${options["css-name"]}`,
                template: template
            });

            {
                mediator.model.set("appView", rootView)
                log("mediator notified of 'appView'");
            }

            // render this view within the app `region`
            {
                // must be a class, not an id
                let appletRegion = $("." + options["region"]);
                if (appletRegion.length) {
                    appletRegion.append(rootView.el);
                    rootView.render();
                    log("appView rendered");
                } else {
                    console.error("could not find applet region: ", options["region"]);
                }
            }

            // create the map once the application starts
            this.on("start", () => {
                this.createMapView();
                // TODO: drop this, use mediator.mapView instead
                _.delay(() => this.trigger("running", this));
            });

            // the application is ready to start (defer responsibility to call start())
            this.trigger("ready-to-start", this);

        });

    }

    onBeforeDestroy() {
        log("destroying the maplet controller");
        this.unbind();
    }

    get mediator() {
        return this.api.mediator;
    }

    // helper to determine how to find a view (by id)
    private hasView(id: string) {
        return 0 < $("#" + id).length;
    }

    /**
     HACK05
    TODO: should be handled by a controller which has access to the mediator which forwards mapView events to the mediator
    TODO: should make use of Controller for registering events, commands, etc.
    */
    private createMapView() {

        if (!this.applet.Map) return;

        // TODO: remove, applet-region was for the appView
        let options = _.defaults(Utils.asDictionary(this.applet.Options.Values), {
            region: "applet-region"
        });

        let mapletOptions = _.defaults(Utils.asDictionary(this.applet.Map.Options.Values), {
            region: "maplet-region"
        });

        // TODO: push this out into a controller which sets 'mapView' on mediator
        let mapControl = Templates.asControlTemplate({
            id: "map-control",
            mid: "app/controls/map"
        });

        mapControl.Options.Values = Utils.asOptions({
            region: mapletOptions["region"]
        });

        let mapController = new MapController(mapControl, this.mediator, {
            applet: this.applet
        });
        mapController.createView();

    }
}

export = RhythmGIS;
